export const pt = {
  save: "Guardar",
  update: "Atualizar",
  accept: "Aceitar",
  cancel: "Cancelar",
  close: "Fechar",
  add: "Adicionar",
  check: "Verificar",
  certificate: "Certificado",
  certificates: "Certificados",
  certification: "Certificação",
  certifications: "Certificações",
  "valid-certificate": "Certificado válido",
  date: "Data",
  "valid-thru": "Válido até",
  dashboard: "Página inicial",
  error: "Página de erro",
  forms: "Formulários",
  notifications: "Notificações",
  "my-profile": "O meu perfil",
  "my-documents": "Os meus documentos",
  "no-documents-available": "Não há documentos disponíveis",
  "training-materials": "Materiais de formação",
  "open-in-webviewer": "Abrir no visualizador",
  expired: "Expirado",
  "expired-training-materials": "Materiais de formação expirados",
  "register-headline": "Registo",
  register: "Registar",
  search: "Pesquisa",
  print: "Imprimir",
  "printed-via": "Impresso através de www.evalcard.com",
  settings: {
    label: "Configurações",
    publicProfile: {
      showEmailInPublic: "Mostrar o e-mail",
      showPhoneInPublic: "Mostrar o número de telefone",
      showAddressInPublic: "Mostrar o endereço",
    },
  },
  tables: "Tabelas",
  tabs: "Separadores",
  myeval: "EvalCard",
  "eval-id": "Eval-ID",
  id: "ID",
  timeline: "Cronologia",
  typography: "Tipografia",
  admin: "Administrador",
  user: "Utilizador",
  templateAuthor: "Criador global de modelos",
  users: "Utilizador",
  "user-profile": "Perfil de utilizador",
  "company-name": "Nome da empresa",
  "company-logo": "Logotipo da empresa",
  "company-profile": "Perfil da empresa",
  "company-profile-admin": "Perfil da empresa",
  "company-invitation": "Convite da empresa",
  "invitation-sent": "Convite enviado",
  "new-password": "Nova palavra-passe",
  "generate-new-password": "Gerar nova palavra-passe",
  "current-password": "Palavra-passe atual",
  "repeat-password": "Repetir a palavra-passe",
  "password-successfully-changed": "A sua palavra-passe foi alterada com êxito",
  "password-reset": "Redefinir a palavra-passe",
  "edit-user-profile": "Editar o perfil de utilizador",
  "edit-user-profile-admin": "Editar o perfil de utilizador",
  system: "Sistema",
  widgets: "Widgets",
  wizard: "Assistente",
  logout: "Terminar sessão",
  login: "Iniciar sessão",
  companies: "Empresas",
  "my-company": "A minha empresa",
  "leave-company": "Sair da empresa",
  "delete-company": "Eliminar a empresa",
  company: "Empresa",
  uid: "NIF/número fiscal",
  employees: "Funcionários",
  employee: "Funcionário/a",
  companyadmin: "Admin",
  evalclient: "Responsável EVAL",
  coworker: "Funcionários",
  "coworker-profile": "Perfil do funcionário",
  "search-user": "Procurar utilizador",
  "search-user-placeholder": "Nome, e-mail, EVAL-ID",
  trainer: "Formador",
  "training-level": "Nível de formação",
  gtp: "GTP",
  authorityAdmin: "Admin",
  trainerRO: "Formador (apenas leitura)",
  authorityAdminRO: "Admin (apenas leitura)",
  protocols: "Relatórios de inspeção",
  report: "Relatório de inspeção",
  "new-report": "Novo relatório de inspeção",
  "all-reports": "Todos os relatórios de inspeção",
  "all-assets": "Todos os objetos",
  "report-from": "Relatório de inspeção de",
  "report-details": "Detalhes do relatório de inspeção",
  data: "Dados",
  info: "Informações",
  attachment: "Anexo",
  contact: "Contacto",
  continue: "Continuar",
  start: "Iniciar",
  summary: "Resumo",
  vin: "VIN",
  "licence-plate": "Matrícula",
  owner: "Proprietário",
  vehicles: "Veículos",
  vehicle: "Veículo",
  "vehicle-details": "Detalhes do veículo",
  companyVehicle: "Veículo da empresa",
  valid: "Conforme",
  invalid: "Não conforme",
  tester: "Inspetor",
  "vehicles-admin": "Veículos",
  "create-company-vehicle": "Criar veículo",
  "select-vehicle": "Seleção de veículo",
  "my-vehicles": "Os meus veículos",
  "my-vehicle": "O meu veículo",
  asset: "Objeto",
  assets: "Objetos",
  "serial-number": "Número de série",
  "asset-type": "Tipo de objeto",
  "asset-types": "Tipos de objeto",
  "calibration-valid-thru": "Calibração válida até",
  "requires-calibration": "Deve ser calibrado regularmente",
  "calibration-warning-days": "Prazo de aviso (dias)",
  "gtp-classes": "Classes GTP",
  code: "Código",
  subtype: "Subtipo",
  icon: "Ícone",
  qualification: "Qualificação (HTML)",
  gtpIcon: {
    car: "Automóvel",
    forklift: "Empilhador",
    gauge: "Taquímetro",
    "train-front": "Comboio",
    ship: "Navio",
    plane: "Avião",
    settings: "Engrenagem",
    wrench: "Chave de bocas",
  },
  photos: "Fotografias",
  "new-vehicle": "Novo veículo",
  manufacturer: "Fabricante",
  "no-manufacturer": "(Nenhum fabricante)",
  "no-vehicle": "(Nenhum veículo)",
  "vehicle-manufacturer": "Fabricante do veículo",
  "create-vehicle": "Criar veículo",
  "create-vehicle-manufacturer": "Criar fabricante de veículos",
  "construction-year": "Ano de fabrico",
  "change-password": "Alterar a palavra-passe",
  roles: "Permissões",
  actions: "Ações",
  action: "Ação",
  profile: "Perfil",
  email: "E-mail",
  basic: "Base",
  special: "Especial",
  breakdown: "Distribuição",
  "click-for-details": "Clique para ver os detalhes",
  rights: "Direitos",
  details: "Detalhes",
  information: "Informações",
  "details-and-information": "Detalhes e informações",
  name: "Nome",
  namename: "Designação",
  firstname: "Nome próprio",
  lastname: "Apelido",
  fullname: "Nome completo",
  password: "Palavra-passe",
  street: "Rua",
  number: "Número",
  city: "Cidade",
  country: "País",
  "forgot-password": "Esqueceu-se da palavra-passe?",
  "recover-password": "Redefinir a palavra-passe",
  back: "Voltar",
  "back-to-login": "Voltar ao início de sessão",
  "go-to-login": "Ir para o início de sessão",
  "choose-picture": "Selecionar imagem",
  "choose-logo": "Selecionar logotipo",
  "image-format-not-supported": "Este formato de imagem não é suportado. Selecione uma imagem JPG ou PNG.",
  "send-invitation": "Enviar convite",
  zipcode: "Código postal",
  previous: "Voltar",
  abort: "Cancelar",
  "i-understand": "Compreendido",
  no: "Não",
  yes: "Sim",
  inputs: "Entradas",
  "user-activated": "Ativado",
  "user-not-activated": "O utilizador ainda não está ativado",
  "user-did-not-receive-activation-email": "O utilizador ainda não recebeu o e-mail de ativação",
  "allow-coworkers-to-show-on-profile": "Mostrar no perfil de utilizador dos funcionários:",
  "resend-activation-email": "Solicitar link de ativação",
  "coworker-education-status": "Estado de formação dos funcionários",
  card: "Cartão de visita",
  "certification-authority": "Organismo de certificação",
  "certification-authority-admin": "Organismo de certificação",
  "certification-authorities": "Organismos de certificação",
  "delete-certification-authority": "Eliminar o organismo de certificação",
  "certificate-templates": "Modelos de certificado",
  "certificate-template": "Modelo de certificado",
  "creating-certificates": "Os certificados estão a ser criados...",
  "issue-certificate": "Emitir o certificado",
  "issue-date": "Data de emissão",
  "due-date": "Data de expiração",
  "issued-on": "Emitido em",
  "issued-by": "Emitido por",
  author: "Emissor",
  "certificate-name": "Nome do certificado",
  "certificate-number": "Número do certificado",
  "born-on": "nascido em",
  mileage: "Quilometragem",
  public: "Público",
  "back-to-the-app": "Voltar à aplicação",
  "can-create-reports": "Relatórios de inspeção possíveis",
  "temporary-certification": "Certificação temporária",
  "temporary-days-valid": "Válido durante (dias)",
  "valid-for": "Válido durante (anos)",
  "pdf-template": "Modelo PDF",
  "pdf-certificate": "Certificado PDF próprio",
  "show-pdf-certificate": "Certificado em PDF",
  standards: "Normas (HTML)",
  "text-block": "Texto após as normas (HTML)",
  "text-block-hint": "Marcador de posição: {placeholders} — qualifikationen insere os textos das classes GTP atribuídas",
  "digital-signature": "Assinatura digital",
  eval0: "HV-0",
  eval1: "HV-1",
  eval2: "HV-2",
  eval3: "HV-3",
  eval4: "HV-4",
  evalc: "HV-C",
  evalbex: "HV-BEX",
  evall: "HV-L",
  evalf: "HV-F",
  evalpro: "HV-Pro",
  evals: "HV-S",
  evalt: "HV-T",
  sonstige: "Outros",
  others: "Outro",
  levelGroupBase: "Níveis básicos",
  levelGroupSpecial: "Especial – requer formação prévia",
  levelGroupSpecialTraining: "Formações especiais sem requisitos",
  level: "Nível",
  type: "Tipo",
  "training-data": "Materiais de formação",
  "training-info": "Informações sobre a formação",
  "generated-password": "Palavra-passe gerada",
  "invitation-email": "E-mail de convite",
  document: "Documento",
  documents: "Documentos",
  active: "ativo",
  inactive: "inativo",
  all: "TODOS",
  "all-sort": "Todos/Ordenar",
  "created-on": "Criado em",
  result: "Resultado",
  results: "Resultados",
  "try-again": "Tentar novamente",
  status: "Estado",
  published: "Publicado",
  draft: "Rascunho",
  sn: "SN",
  "something-went-wrong": "Algo correu mal",
  "checking-prerequisites": "Os requisitos estão a ser verificados...",
  "prerequisite-warning-title": "Requisitos em falta",
  "missing-prerequisites": "Requer no mínimo:",
  "info-signs": "Placas de aviso",
  danger: "Atenção",
  "hazardous-voltage": "Tensão perigosa",
  "no-access-1": "A pessoas não autorizadas",
  "no-access-2": "Entrada proibida",
  "access-only-by": "Acesso apenas por",
  "company-logo-is-missing": "Falta o logotipo da empresa",
  download: "Descarregar",
  "access-denied": "Entrada proibida",
  "dont-switch-on": "Não ligar",
  "hv-system": "Sistema de alta tensão",
  disconnected: "Consignado",
  "disconnected-by": "Consignado por",
  "works-in-progress": "Trabalhos em curso",
  forum: "Fórum EV",
  topic: "Tópico",
  topics: "Tópicos",
  title: "Título",
  created: "Criado",
  "created-by": "Criado por",
  "is-global": "Modelo global",
  "templateauthor-requires-report-permission": "Apenas os utilizadores autorizados a criar relatórios podem tornar-se criadores globais de modelos.",
  from: "de",
  answers: "Respostas",
  "post-answer": "Publicar resposta",
  "edit-answer": "Editar resposta",
  "new-topic": "Novo tópico",
  "edit-topic": "Editar tópico",
  "create-new-topic": "Criar novo tópico",
  "last-answer": "Última resposta",
  "view-all": "Ver tudo",
  attachments: "Anexos",
  "link-url": "Link (URL)",
  "newest-topics": "Tópicos mais recentes",
  "privacy-policy": "Proteção de dados",
  "new-files": "Novos ficheiros",
  "existing-files": "Ficheiros existentes",
  courses: "Cursos",
  location: "Localização",
  loading: "Carregar",
  "view-details": "Mostrar detalhes",
  "no-courses-found": "Nenhum curso encontrado",
  "no-courses-assigned": "Não há cursos disponíveis",
  dialog: {
    "are-you-sure": "Tem a certeza?",
    "an-unexpected-error-occured": "Ocorreu um erro inesperado. Tente novamente mais tarde",
    "do-you-really-want-the-user-to": "Deseja realmente o utilizador",
    "do-you-really-want-the-invitation-to": "Deseja realmente o convite",
    delete: "eliminar",
    "delete-user": "Eliminar utilizador",
    "delete-topic": "Eliminar tópico",
    "delete-topic-answer": "Eliminar resposta",
    "remove-user": "Remover utilizador",
    "remove-trainer": "Remover inspetor",
    "remove-from-company": "remover da empresa?",
    "remove-from-certification-authority": "remover do organismo de certificação?",
    "create-user": "Criar utilizador",
    "the-most-important-information": "As informações mais importantes",
    "create-company": "Criar empresa",
    "the-most-important-information-about-the-company": "As informações mais importantes da empresa",
    "create-company-vehicle": "Criar veículo da empresa",
    "the-most-important-information-about-the-vehicle": "As informações mais importantes do veículo",
    "the-most-important-information-about-the-asset": "As informações mais importantes do objeto",
    "create-report": "Criar relatório de inspeção",
    "where-is-the-company-located": "Onde se situa a empresa?",
    "where-is-the-certification-authority-located": "Onde se situa o organismo de certificação?",
    "whats-the-role-of-the-person": "Que função tem a pessoa?",
    "where-does-the-person-live": "Onde mora a pessoa?",
    "further-details": "Mais detalhes",
    "register-successfull": "O registo foi bem-sucedido! Receberá em breve um e-mail com a sua palavra-passe.",
    "great-you-will-receive-an-email": "Receberá em breve um e-mail com o qual poderá redefinir a sua palavra-passe",
    "this-should-not-take-longer-than": "Isto não deverá demorar mais de 5 minutos. Se demorar, verifique também a sua pasta de spam.",
    "i-agree": "Aceito os",
    "terms-and-conditions": "termos e condições gerais",
    "hereby-i-agree": "Pela presente aceito que a EvalCert GmbH possa utilizar os meus dados pessoais para efeitos de emissão de um cartão EVAL e de registo de utilizadores em my.evalcard.com.",
    "further-i-agree-to": "Aceito ainda que a EvalCert GmbH me possa informar por newsletter por e-mail sobre novidades na área da alta tensão (novas formações, novos produtos ou eventos), até revogação.",
    "allowed-to-be-used": " (.de ou .com) pode ser utilizado.",
    "refusal-is-allways": "A revogação é possível em qualquer momento por e-mail para",
    possible: "possível.",
    "the-e-val-card-is-the": "O cartão EVAL é o comprovativo de qualificação em formato de cartão. A abreviatura EVAL significa Electric Vehicle Access License",
    "complete-user-data": "Completar os dados de utilizador",
    "complete-user-data-info": "Para podermos apoiá-lo da melhor forma possível e disponibilizar-lhe todas as funções, necessitamos de um perfil de utilizador totalmente preenchido",
    "your-password-reset-is-being-processed": "A sua palavra-passe está a ser redefinida neste momento. Se demorar mais do que alguns minutos, tente novamente.",
    "your-password-has-been-sent": "A sua palavra-passe foi redefinida com êxito. Dentro de poucos minutos deverá receber um e-mail com a sua nova palavra-passe.",
    "if-it-did-not-work": "Verifique também a sua pasta de spam. Se não receber a sua nova palavra-passe no prazo de 5-10 minutos, tente novamente.",
    "user-not-authorized": "E-mail e/ou palavra-passe incorretos",
    "user-not-activated": "Este utilizador ainda não está ativado. Utilize o link do e-mail de ativação",
    "user-or-password-wrong": "O e-mail ou a palavra-passe estão incorretos",
    "users-selected": "Utilizador selecionado",
    "user-profile-update-successfull": "O perfil de utilizador foi guardado com êxito",
    "user-profile-update-failed": "Não foi possível guardar o perfil de utilizador. Tente novamente mais tarde.",
    "do-you-really-want-to-leave-the-company": "Deseja realmente sair da empresa?",
    "in-order-to-accept-a-company-invitation": "Para poder aceitar um convite de empresa, tem de estar já registado e com sessão iniciada",
    "do-you-really-want-to-join-the-company": "Tem a certeza de que quer aderir à empresa?",
    "if-you-are-already-in-a-company-you-will-be-removed": "Se já pertencer a uma empresa, será removido dela",
    "you-are-not-a-member-of-a-company": "Atualmente não está atribuído a nenhuma empresa. Assim que for membro de uma empresa, poderá utilizar esta página.",
    "you-are-not-a-member-of-a-certification-authority": "Atualmente não está atribuído a nenhum organismo de certificação",
    "do-you-really-want-the-company-to": "Deseja realmente a empresa",
    "company-created-successfully": "A empresa foi criada com êxito",
    "company-already-exists": "Já existe uma empresa com este nome ou este e-mail. Por isso não foi possível criar a empresa",
    "vehicle-save-successfully": "O veículo foi guardado com êxito",
    "asset-save-successfully": "O objeto foi guardado com êxito",
    "gtp-class-save-successfully": "A classe GTP foi guardada com êxito",
    "gtp-class-already-exists": "Já existe uma classe GTP com este código",
    "do-you-really-want-the-gtp-class-to": "Deseja realmente a classe GTP",
    "asset-type-save-successfully": "O tipo de objeto foi guardado com êxito",
    "do-you-really-want-the-asset-type-to": "Deseja realmente o tipo de objeto",
    "vehicle-already-exists": "Já existe um veículo com este VIN e proprietário",
    "vehicle-accepted": "O veículo foi integrado no sistema",
    "vehicle-manufacturer-accepted": "O fabricante do veículo foi integrado no sistema",
    "report-save-successfully": "O relatório de inspeção foi guardado com êxito",
    "report-already-exists": "Já existe um relatório de inspeção com este nome ou tipo nesta empresa.",
    "create-company-failed": "Não foi possível criar a empresa. Tente novamente mais tarde.",
    "save-user-success": "O utilizador foi guardado com êxito",
    "user-already-exists": "Já existe um utilizador com este e-mail ou este nome.",
    "save-company-success": "A empresa foi guardada com êxito",
    "save-company-failed": "Não foi possível guardar a empresa. Tente novamente mais tarde.",
    "save-changes-success": "As alterações foram guardadas com êxito",
    "do-you-really-want-the-vehicle-to": "Deseja realmente o veículo",
    "do-you-really-want-the-asset-to": "Deseja realmente o objeto",
    "do-you-really-want-the-report-to": "Deseja realmente o relatório de inspeção",
    "do-you-really-want-the-certificate-to": "Deseja realmente o certificado",
    "do-you-really-want-the-vehicle-manufacturer-to": "Deseja realmente o fabricante do veículo",
    "save-vehicle-manufacturer-success": "O fabricante do veículo foi guardado com êxito",
    "save-vehicle-manufacturer-error": "Não foi possível guardar o fabricante do veículo",
    "save-vehicle-success": "O veículo foi guardado com êxito",
    "save-vehicle-error": "Não foi possível guardar o veículo",
    "who-works-in-the-company": "Quem trabalha na empresa?",
    "who-works-in-the-certification-authority": "Quem trabalha no organismo de certificação?",
    "your-company-has-been-created-check-your-emails": "A sua empresa foi criada! Deverá receber em breve um e-mail com o qual poderá ativar a sua empresa! Se necessário, verifique também a sua pasta de spam.",
    "if-you-havent-received-an-email-yet": "Se não receber nenhum e-mail no prazo de 5 minutos, pode solicitá-lo novamente aqui.",
    "if-this-did-not-work": "Se ainda assim não funcionar, pode também sair da sua empresa e criar uma nova.",
    "is-already-in-a-company": "já pertence a uma empresa",
    "invite-user-already-exists-in-company": "O utilizador com este e-mail já está na empresa",
    "invite-user-already-exists-in-other-company": "O utilizador com este e-mail já está noutra empresa",
    "create-certification-authority": "Criar organismo de certificação",
    "certification-authority-save-successfully": "O organismo de certificação foi guardado com êxito",
    "certification-authority-already-exists": "Já existe um organismo de certificação com este e-mail ou este nome.",
    "certificate-already-exists": "Já existe uma certificação com este nome para este utilizador.",
    "certificate-save-successfully": "A certificação foi guardada com êxito",
    "do-you-really-want-to-delete": "Deseja realmente eliminar",
    "delete-report-template": "Eliminar modelo",
    "create-certificate": "Criar certificado",
    "create-certificate-template": "Criar modelo de certificado",
    "who-gets-the-certificate": "A quem deve ser emitido o certificado",
    "user-with-this-eval-id-was-not-found": "Não foi encontrado nenhum utilizador com este Eval-ID",
    "you-can-only-add-reports-if-you-have-company-vehicles": "Só pode criar um relatório se possuir veículos da empresa",
    "you-can-only-input-eu-numbers": "Apenas são possíveis números no formato UE",
    "you-dont-have-the-rights": "Sem permissão para esta área",
    "certificate-template-save-success": "O modelo de certificado foi guardado com êxito",
    "certificate-template-sort-save-success": "A ordenação dos modelos de certificado foi guardada com êxito",
    "your-certification-authority-does-not-have-templates": "Crie primeiro um modelo de certificado para poder emitir certificados",
    "this-company-is-not-yet-activated": "Esta empresa ainda não foi ativada. O link de ativação foi enviado para o endereço de e-mail da empresa",
    "welcome-to-the-dashboard": "Bem-vindo à página inicial! Atualmente não está atribuído a nenhuma empresa. Assim que for membro de uma empresa, poderá ver aqui uma visão geral dos seus protocolos",
    "valid-certificates": "Certificados válidos",
    "certificates-last-30-days": "Certificados – últimos 30 dias",
    "certificates-on": "Certificados em",
    "reports-last-30-days": "Relatórios – últimos 30 dias",
    "no-data-available": "Ainda não existem dados",
    "this-manufacturer-does-not-exist": "Este fabricante ainda não está no sistema. Será criado automaticamente para si.",
    "this-vehicle-does-not-exist": "Este veículo ainda não está no sistema. Será criado automaticamente para si.",
    "required-to-complete-registration": "Para concluir o registo é necessário um consentimento",
    "email-is-already-used": "Este e-mail já está em uso",
    "enter-valid-birthday-date": "Introduza uma data de nascimento válida",
    "enter-valid-eu-number-format": "Utilize apenas números no formato UE",
    "only-use-numbers-with-or": "Utilize apenas números e '-' ou '/'",
    "this-user-is-already-in-this-certification-authority": "Este utilizador já está neste organismo de certificação",
    "this-user-is-already-selected": "Este utilizador já está selecionado",
    "this-user-is-already-in-a-company": "Este utilizador já está numa empresa",
    "the-document-could-not-be-loaded": "Não foi possível carregar o documento",
    continue: "Continuar",
    finish: "Concluído",
    "cannot-add-users": "Os seguintes utilizadores tiveram conflitos:",
    "add-course": "Adicionar curso",
    "course-created-successfully": "Curso criado com êxito.",
    "course-updated-successfully": "Curso atualizado com êxito.",
    "mark-course-as-free": "Marcar o curso como gratuito",
    "scan-qr-code": "Ler o código QR",
    "scan-to-join-course": "Leia o código QR para aderir ao curso",
    "remove-participant": "Remover participante",
    "remove-participant-description": "Remover este participante do curso?",
    "user-is-already-participant": "Este utilizador já é participante do curso",
    "user-already-selected": "O utilizador já foi selecionado",
    "delete-course": "Eliminar curso",
    "delete-course-description": "Este curso será eliminado. Todos os participantes serão removidos. Continuar?",
    "course-removed": "O curso foi removido",
    "remove-efk-success": "Estado ESP removido com êxito",
    "create-checklist": "Criar lista de verificação",
    "make-efk-success": "Estado ESP atribuído com êxito, o utilizador foi notificado",
    "resend-efk-success": "O convite ESP foi enviado novamente",
    "participants-added-successfully": "Participante adicionado com êxito",
    "delete-document": "Eliminar documento",
    "delete-document-description": "Deseja realmente eliminar este documento?",
    "delete-certificate-template": "Eliminar modelo de certificado",
    "do-you-really-want-the-certificate-template-to": "Deseja realmente o modelo de certificado",
    "do-you-really-want-the-certification-authority-to": "Deseja realmente o organismo de certificação",
    "delete-task": "Eliminar tarefa",
    "do-you-really-want-to-delete-the-task": "Deseja realmente eliminar a tarefa «{name}»?",
    "delete-section": "Eliminar secção",
    "do-you-really-want-to-delete-the-section": "Deseja realmente eliminar a secção «{name}»?",
    "course-content-saved-successfully": "Conteúdos do curso guardados com êxito",
    "remove-certification-authority": "Remover organismo de certificação",
    "do-you-really-want-to-remove-certification-authority": "Deseja realmente remover o organismo de certificação «{name}»?",
    "remove-course-content": "Remover conteúdo do curso",
    "do-you-really-want-to-remove-course-content": "Deseja realmente remover o conteúdo do curso «{name}»?",
    "successfully-removed-course-content": "Conteúdo do curso removido com êxito",
    "language-already-exists-in-course": "O idioma selecionado já existe neste curso",
    "do-you-really-want-to-remove-course": "Deseja realmente remover o curso «{name}»?",
    "successfully-removed-course": "Curso removido com êxito",
    "publish-course-warning": "Tem a certeza de que quer publicar «{name}»? Após a publicação, o curso já não pode ser editado até que a publicação seja retirada.",
    "unpublish-course-confirmation": "Tem a certeza de que quer retirar a publicação de «{name}»? Isso permite novamente alterações.",
    "course-published-successfully": "Curso publicado com êxito",
    "course-unpublished-successfully": "Publicação do curso retirada com êxito",
    "successfully-enrolled-course": "Inscrição no curso efetuada com êxito",
    "remove-enrollment": "Remover inscrição",
    "do-you-really-want-to-remove-enrollment": "Deseja realmente remover esta inscrição?",
    "successfully-removed-enrollment": "Inscrição removida com êxito",
  },
  tooltip: {
    "csv-export": "Exportação CSV",
    "add-user": "Adicionar utilizador",
    "invite-user": "Convidar utilizador",
    "delete-user": "Eliminar utilizador",
    "remove-user": "Remover utilizador",
    "edit-user": "Editar utilizador",
    "view-user": "Ver utilizador",
    "send-invitation-again": "Reenviar convite",
    "send-activation-again": "Reenviar link de ativação",
    "admin-cant-leave-company": "Como responsável EVAL não pode sair da empresa",
    "leave-company": "Sair da empresa",
    "add-company": "Adicionar empresa",
    "edit-company": "Editar empresa",
    "delete-company": "Eliminar empresa",
    "add-selected-users-to-company": "Adicionar os utilizadores selecionados a uma empresa",
    "add-selected-users-to-course": "Adicionar os utilizadores selecionados a um curso",
    "add-vehicle": "Adicionar veículo",
    "show-vehicle": "Detalhes do veículo",
    "edit-vehicle": "Editar veículo",
    "view-vehicle": "Ver veículo",
    "accept-vehicle": "Integrar o veículo no sistema",
    "accept-vehicle-manufacturer": "Integrar o fabricante do veículo no sistema",
    "delete-vehicle": "Eliminar veículo",
    "add-asset": "Adicionar objeto",
    "add-gtp-class": "Adicionar classe GTP",
    "edit-gtp-class": "Editar classe GTP",
    "delete-gtp-class": "Eliminar classe GTP",
    "add-asset-type": "Adicionar tipo de objeto",
    "edit-asset-type": "Editar tipo de objeto",
    "delete-asset-type": "Eliminar tipo de objeto",
    "show-asset": "Detalhes do objeto",
    "edit-asset": "Editar objeto",
    "delete-asset": "Eliminar objeto",
    "add-vehicle-manufacturer": "Adicionar fabricante de veículos",
    "edit-vehicle-manufacturer": "Editar fabricante de veículos",
    "delete-vehicle-manufacturer": "Eliminar fabricante de veículos",
    "vehicle-details-missing": "Faltam os detalhes do veículo",
    "remove-invitation": "Eliminar convite",
    "send-missing-activations": "Enviar os e-mails de ativação em falta",
    "show-password": "Mostrar a palavra-passe",
    "hide-password": "Ocultar a palavra-passe",
    "create-report": "Criar relatório de inspeção",
    "select-for-report": "Selecionar para o relatório de inspeção",
    "add-question": "Adicionar campo",
    "remove-question": "Remover campo",
    "create-certificates": "Criar certificados",
    "view-certificate": "Ver certificado",
    "delete-certificate": "Eliminar certificado",
    "view-report": "Ver relatório de inspeção",
    "delete-report": "Eliminar relatório de inspeção",
    "no-pdf-found": "Não foi encontrado nenhum documento PDF",
    "add-report": "Adicionar relatório de inspeção",
    "add-certificate": "Criar certificado",
    "no-certificate-to-create-report": "Não tem um certificado adequado",
    "add-certification-authority": "Criar organismo de certificação",
    "edit-certification-authority": "Editar organismo de certificação",
    "delete-certification-authority": "Eliminar organismo de certificação",
    "add-certificate-template": "Criar modelo de certificado",
    "edit-certificate-template": "Editar modelo de certificado",
    "delete-certificate-template": "Eliminar modelo de certificado",
    "add-report-template": "Adicionar modelo de relatório",
    "edit-report-template": "Editar modelo de relatório",
    "delete-report-template": "Eliminar modelo de relatório",
    "view-certificate-training-data": "Ver materiais de formação",
    "save-sorting": "Guardar a ordenação",
    "mark-user": "Marcar utilizador",
    "open-topic": "Ver tópico",
    "edit-topic": "Editar tópico",
    "delete-topic": "Eliminar tópico",
    "edit-topic-answer": "Editar resposta",
    "delete-topic-answer": "Eliminar resposta",
    "select-all-users": "Marcar todos os utilizadores",
    "add-course": "Adicionar curso",
    "show-qr": "Mostrar o código QR",
    "edit-course": "Editar curso",
    "publish-course": "Publicar curso",
    "unpublish-course": "Retirar a publicação do curso",
    "remove-course": "Eliminar curso",
    "view-course": "Ver curso",
    "remove-efk": "Remover estado ESP",
    "see-more": "Mostrar mais",
  },
  phone: "Número de telefone",
  address: "Endereço",
  birthday: "Data de nascimento",
  "profile-picture": "Foto de perfil",
  userprofile: {
    "edit-profile": "Editar perfil",
    "public-profile": "Perfil público",
    "following-information": "As seguintes informações são apresentadas no seu perfil público",
    "notification-settings": "Se a sua empresa não enviar notificações, esta configuração não tem efeito",
  },
  "training-director": "Diretor de formação",
  "participated-the-training": "participou na formação ",
  "result-protocol": "Protocolo de resultados",
  measurements: "Valores medidos",
  freischaltung: "Consignação",
  isolationswiderstand: "Resistência de isolamento",
  potentialausgleich: "Ligação equipotencial",
  r: {
    "measuring-instrument-functionality": "Função do aparelho de medição",
    "positive-test-done": "Teste positivo realizado",
    "voltage-between-hv-plus-and-chassis": "Tensão entre HV-mais e chassis",
    "voltage-between-hv-plus-and-hv-minus": "Tensão entre HV-mais e HV-menos",
    "voltage-between-hv-minus-and-chassis": "Tensão entre HV-menos e chassis",
    "the-tester-accepts-the-security-instructions": "O inspetor confirma o cumprimento das instruções de segurança do fabricante",
    "measuring-instrument-tested-at-reference-source": "A função do aparelho de medição foi verificada numa fonte de referência?",
    "measuring-instrument-tested": "A função do aparelho de medição foi verificada?",
    "absence-of-voltage": "Ausência de tensão",
    "absence-of-voltage-confirmed": "Ausência de tensão constatada",
    voltage: "Tensão (V)",
    "used-voltage": "Tensão utilizada",
    "used-test-voltage": "Tensão de ensaio aplicada",
    "isolation-standard": "Valor nominal da resistência de isolamento",
    "resistance-per-volt": "Resistência por volt",
    "hv-system-voltage": "Tensão de serviço AT / tensão do sistema AT",
    "isolation-resistance-between-hv-plus-and-chassis": "Resistência de isolamento entre HV-mais e chassis",
    "isolation-resistance-between-hv-minus-and-chassis": "Resistência de isolamento entre HV-menos e chassis",
    "further-measurements-if-needed": "Outra medição se desejado",
    "test-current": "Corrente de ensaio (A)",
    "test-current-q": "Corrente de ensaio ...",
    "measuring-point": "Ponto de medição",
    "measuring-point-chassis-vs": "Ponto de medição chassis contra ...",
    "converter-housing": "Caixa do inversor",
    "further-voltage-measurements-if-needed": "Outra medição de tensão se desejado",
    "measurements-ok-if-smaller-than-1-v": "Resultado da medição positivo se a tensão medida for inferior a 1 V",
    "visual-inspection": "Inspeção visual",
    "cable-visual-inspection": "O cabo foi verificado quanto a danos visíveis?",
    "connector-visual-inspection": "A ficha foi verificada quanto a danos visíveis?",
    "isolation-test": "Ensaio de isolamento",
    "cable-isolation-test": "A resistência de isolamento do cabo foi verificada?",
    "function-test": "Teste de funcionamento",
    "cable-function-test": "O processo de carregamento foi testado com êxito?",
    "charging-cable-inspection-notes": "Outras verificações se necessário",
  },
  "new-report-no-id": "Novo relatório de inspeção",
  "required-field": "Este campo é obrigatório.",
  "fill-out-all-required-fields": "Preencha todos os campos obrigatórios!",
  "valid-email-only": "Introduza um e-mail válido.",
  "max-characters": "Máx. {count} caracteres",
  "certificate-notification": "Notificações de certificados",
  "certificate-notification-company": "Com isto podem ser desativadas as notificações para todos os funcionários.",
  "calibration-notification": "Notificações de calibração",
  "calibration-notification-company": "Lembrete antes de a calibração de um objeto expirar.",
  "haynes-pro-vehicle-details": "Detalhes do veículo HaynesPro",
  "haynes-pro-no-details": "Não estão disponíveis detalhes para o veículo selecionado.",
  "haynes-pro-hv-disconnect": "Sistema de alta tensão: colocar sem tensão",
  "vehicle-details-admin": "Detalhes do veículo",
  "haynes-pro-details": "Detalhes HaynesPro",
  "haynes-pro-details-admin": "Detalhes HaynesPro",
  "haynes-pro-details-not-found": "Infelizmente não foi encontrado nada para este veículo.",
  "haynes-pro-load-error": "Não foi possível carregar as instruções.",
  retry: "Tentar novamente",
  "haynes-pro-details-more-than-one-story": "Foi encontrada mais de uma instrução:",
  participants: "Participantes",
  "join-course": "Aderir ao curso",
  "join-course-description": "Aderir realmente ao curso? O formador do curso poderá então geri-lo como participante.",
  "course-id-required": "O ID do curso é obrigatório para aderir a um curso!",
  "course-not-found": "Curso não encontrado",
  "error-loading-course": "Erro ao carregar o curso",
  "successfully-joined-course": "Adesão ao curso efetuada com êxito",
  "error-joining-course": "Erro na adesão, contacte o seu formador.",
  refresh: "Recarregar",
  "edit-course": "Editar curso",
  "make-efk": "Nomear como ESP",
  "make-efk-description": "Nomear este utilizador como ESP? Ele tem de confirmar.",
  "resend-efk-invitation": "Reenviar o convite ESP",
  "cancel-efk": "Cancelar a nomeação ESP",
  efk: "ESP",
  "efk-position": "Posição de ESP (eletricista qualificado)",
  "do-you-want-to-accept-efk-position": "Deseja aceitar a posição de ESP (eletricista qualificado)?",
  "do-you-want-to-refuse-efk-position": "Deseja recusar a posição de ESP (eletricista qualificado)?",
  refuse: "Recusar",
  "in-order-to-handle-efk-position": "Para poder aceitar a posição de ESP (eletricista qualificado), tem de estar já registado e com sessão iniciada",
  "efk-position-accepted": "A posição de ESP (eletricista qualificado) foi aceite",
  "efk-position-refused": "A posição de ESP (eletricista qualificado) foi recusada",
  pending: "Pendente",
  "remove-efk-description": "Deseja retirar a posição de ESP a este utilizador?",
  "cancel-efk-description": "Deseja realmente cancelar o convite ESP para este utilizador?",
  aborted: "Recusado",
  checklists: "Listas de verificação",
  "all-checklists": "Todas as listas de verificação",
  manage: "Gerir",
  "global-templates": "Modelos globais",
  "global-template-authors": "Criadores globais de modelos",
  "add-global-template-author": "Adicionar criador global",
  "remove-global-template-author-confirm": "Remover realmente como criador global de modelos?",
  "report-templates": "Modelos de relatório",
  "report-template": "Modelo de relatório",
  "create-report-template": "Criar modelo de relatório",
  "edit-report-template": "Editar modelo de relatório",
  "delete-report-template": "Eliminar modelo de relatório",
  checklist: "Lista de verificação",
  form: "Relatório de inspeção do veículo",
  "basic-information": "Informações básicas",
  "object-data": "Dados do objeto",
  "object-data-configuration": "Configuração dos dados do objeto",
  "object-data-config-description": "Configure campos personalizados para a recolha de dados",
  "requires-vehicle": "Vinculado ao veículo",
  "assigned-vehicles": "Veículos atribuídos",
  "assigned-vehicles-hint": "Vazio = aplica-se a todos os veículos",
  "assigned-vehicles-no-data": "Procurar veículo …",
  "available-reports": "Relatórios disponíveis",
  "create-report-now": "Criar relatório",
  "vehicle-added-to-fleet": "O veículo encontra-se agora nos seus veículos da empresa",
  "requires-asset": "Vinculado ao objeto",
  "select-asset": "Selecionar objeto",
  "field-name": "Nome do campo",
  "display-name": "Nome de exibição",
  "add-field": "Adicionar campo",
  "questions-description": "Configure as perguntas para este modelo",
  "add-question": "Adicionar pergunta",
  "example-images": "Imagens de exemplo",
  "upload-example-images": "Carregar imagens de exemplo",
  "remove-image": "Remover imagem",
  "images-uploaded-successfully": "Imagens carregadas com êxito",
  "error-uploading-images": "Erro ao carregar as imagens",
  "enable-validation": "Ativar a validação",
  "validation-configuration": "Configuração da validação",
  "expected-value": "Valor esperado",
  "at-least-one-language-required": "É necessário pelo menos um idioma",
  "language-not-available": "Este idioma não existe",
  "multilingual-fields-info": "Campos multilingues: introduza apenas os idiomas para os quais tem traduções. É necessário pelo menos um idioma para os nomes e as perguntas.",
  operator: "Operador",
  "validation-value": "Valor de validação",
  equal: "Igual",
  "less-than": "Menor que",
  "greater-than": "Maior que",
  "form-vehicle-info": "Este é um modelo de formulário. Os formulários são utilizados quando é necessário um veículo para o relatório.",
  "checklist-object-data-info": "Este é um modelo de lista de verificação. As listas de verificação utilizam a configuração dos dados do objeto em vez de veículos.",
  "protocols-title": "Relatórios",
  "evalus-reports": "Modelos gerais",
  "company-reports": "Relatórios da empresa",
  "custom-templates": "Modelos personalizados",
  description: "Descrição",
  questions: "Perguntas de verificação",
  question: "Pergunta",
  unit: "Unidade",
  boolean: "Sim/Não",
  text: "Texto",
  "question-type-number": "Número",
  dropdown: "Seleção",
  options: "Opções",
  option: "Opção",
  "add-option": "Adicionar opção",
  "expected-option": "Opção esperada",
  "dropdown-options-required": "Cada pergunta de seleção precisa de pelo menos uma opção preenchida",
  "no-questions-yet": "Ainda não há perguntas — adiciona a primeira",
  "no-fields-yet": "Ainda não há campos — adiciona o primeiro",
  "question-incomplete": "Esta pergunta ainda está incompleta",
  "is-active": "Ativo",
  "add-checklist": "Adicionar lista de verificação",
  "select-checklist-template": "Selecione um modelo de lista de verificação",
  "no-checklist-templates-available": "Não há modelos de lista de verificação disponíveis.",
  template: "Modelo",
  "checklist-object-data": "Dados do relatório",
  "report-template-saved": "O modelo de relatório foi guardado com êxito",
  "new-checklist": "Nova lista de verificação",
  "view-checklist": "Mostrar lista de verificação",
  "checklist-from": "Lista de verificação de",
  "checklist-details": "Detalhes da lista de verificação",
  field: "Campo",
  "checklist-created-successfully": "A lista de verificação foi criada com êxito",
  "error-creating-checklist": "Erro ao criar a lista de verificação. Tente novamente mais tarde.",
  "tested-with-object": "Com o objeto",
  "required-asset-type": "Tipo de objeto necessário",
  "required-asset-type-hint": "Tipo de objeto com o qual esta inspeção do veículo tem de ser realizada. Deixar vazio se não for necessário nenhum objeto.",
  "can-calibrate": "Pode calibrar objetos",
  "calibratable-asset-type": "Tipo de objeto calibrável",
  "calibratable-asset-type-hint": "Apenas os objetos deste tipo podem ser calibrados com esta lista de verificação.",
  "calibration-validity-months": "Validade da calibração (meses)",
  "calibration-validity-months-hint": "Se esta lista de verificação for concluída sem erros, o objeto volta a ser considerado calibrado durante esse número de meses.",
  "select-required-asset": "Objeto utilizado",
  "asset-locked-calibration-expired": "Bloqueado – calibração expirada há mais de {days} dias ({date})",
  "asset-calibration-expired-on": "Calibração expirada em {date}",
  "asset-restricted-hint": "Esta inspeção só pode ser realizada com um objeto do tipo «{type}».",
  "asset-none-of-required-type": "A sua empresa não tem nenhum objeto do tipo «{type}». Crie primeiro um objeto adequado para poder realizar esta inspeção.",
  "asset-all-expired": "Em todos os objetos adequados a calibração expirou há mais de {days} dias, pelo que estão bloqueados. Atualize a data de calibração no objeto para continuar.",
  "asset-no-longer-allowed": "O objeto selecionado (já) não é permitido para esta inspeção – possivelmente a calibração expirou há demasiado tempo. Verifique a seleção.",
  "add-users-to-course": "Adicionar utilizadores ao curso",
  "selected-users": "Utilizadores selecionados",
  "start-date": "Data de início",
  "end-date": "Data de fim",
  "evalus-reports-info": "Aqui encontra os «Modelos gerais». Os relatórios especiais pode encontrá-los, criá-los e geri-los no item de menu «Listas de verificação».",
  role: "Função",
  eup: "EUP",
  "efk-tooltip": "Eletricista qualificado",
  "eup-tooltip": "Pessoa instruída em eletrotecnia",
  "efk-pending": "Nomeação pendente",
  "strictly-required": "Obrigatório",
  "strictly-required-info": "Se ativado, o relatório não pode ser enviado se esta validação falhar",
  "validation-failed": "Validação obrigatória falhou",
  "cannot-submit-invalid-required": "Não é possível enviar: a validação necessária falhou",
  "create-new-entry": "Criar nova entrada",
  "trainer-invalid-certificate": "O formador já não tem um certificado HV-4 ou HV-L válido.",
  to: "até",
  "date-filter": "Filtro de data",
  "clear-filter": "Eliminar filtro",
  "oldest-first": "Mais antigos primeiro",
  "newest-first": "Mais recentes primeiro",
  "course-documents": "Anexos do curso",
  "select-documents": "Selecionar documentos",
  "upload-documents": "Carregar documentos",
  uploading: "Carregar",
  "drag-and-drop-files": "Arraste e largue os ficheiros aqui",
  "drop-files-here": "Largue os ficheiros aqui",
  "or-click-to-browse": "ou clique para selecionar ficheiros",
  "supported-formats": "Formatos suportados",
  "existing-documents": "Documentos existentes",
  "documents-uploaded-successfully": "Documentos carregados com êxito",
  "document-deleted-successfully": "Documento eliminado com êxito",
  "no-course-documents-available": "Atualmente não está atribuído a nenhum curso ou não foram disponibilizados documentos.",
  "more-files": "Mais ficheiros",
  publicProfile: {
    status: {
      valid: "Válido",
      expiringSoon: "Expira em breve",
      expired: "Expirado",
      certified: "Certificado",
      open: "Aberto",
      none: "Nenhuma",
    },
    jobTitle: {
      efk: "HV-ESP",
      hv0: "Pessoa sensibilizada para AT",
      "hv1-3": "HV-EUP",
    },
    experienceStartDate: "Experiência profissional desde",
    backgroundImage: "Imagem de fundo",
    totalCertificatesTitle: "Certificados",
    totalCertificatesDescription: "Número total de certificados",
    trainingLevelTitle: "Nível de formação",
    trainingLevelDescription: "Nível de formação mais elevado",
    practicalOperationsTitle: "Intervenções práticas",
    practicalOperationsDescription: "Atividades práticas em sistemas de AT",
    vehicleModelsTitle: "Modelos de veículos",
    vehicleModelsDescription: "Modelos de veículos de AT assistidos",
    dashboardTitle: "Painel de experiência em AT",
    dashboardSubtitle: "Estatísticas completas e competência em AT",
    certificationsTitle: "Certificações",
    certificationsSubtitle: "Visão geral da formação e do aperfeiçoamento na área da AT",
    instructor: "Instrutor",
    issuedOn: "Emitido",
    validUntil: "Válido até",
    view: "Ver",
    loadMoreCertificates: "Carregar mais certificados",
    hideCertificates: "Ocultar certificados",
    nav: {
      certifications: "Certificações",
      specialTraining: "Formações especiais",
      practicalExperiences: "Experiências práticas",
      vehicleCategories: "Categorias de veículos",
    },
    specialTraining: {
      title1: "Especial",
      title2: "Formações",
      subtitle: "Qualificações adicionais e formações especiais",
    },
    practicalExperiences: {
      title1: "Práticas",
      title2: "Experiências",
      subtitle: "Experiência prática em sistemas de AT",
      freischaltungen: {
        title: "Consignações",
        description: "Consignações realizadas em sistemas de AT",
      },
      isolationstests: {
        title: "Medições de isolamento",
        description: "Medições de resistência de isolamento realizadas",
      },
      potentialtests: {
        title: "Ligação equipotencial",
        description: "Medições de ligação equipotencial realizadas",
      },
      checklists: {
        title: "Listas de verificação realizadas",
        description: "Listas de verificação de segurança concluídas",
      },
      chargingCableChecks: {
        title: "Inspeções de cabos de carregamento",
        description: "Inspeções de segurança de cabos certificadas HV-C",
      },
      issuedCertificates: {
        title: "Certificados emitidos",
        description: "Certificações emitidas como formador",
      },
    },
    vehicleCategories: {
      title1: "Categoria de veículo ",
      title2: "Experiências",
      subtitle: "Especializado nas seguintes categorias de veículos e aplicações",
    },
    gtpCategories: {
      roadVehicles: "Veículos rodoviários",
      machines: "Máquinas de construção",
      racingVehicles: "Veículos de competição",
      aircraft: "Aeronaves",
      watercraft: "Embarcações",
      railVehicles: "Veículos ferroviários",
      developmentProduction: "I&D",
      aftersales: "Pós-venda",
    },
    footer: {
      qrTitle: "Acesso por código QR",
      qrSubtitle: "Leia o código para acesso rápido ao perfil",
      qrHint: "Ler com a câmara",
      copyright: "© {year} Evalcard.com - Todos os direitos reservados",
      imprint: "Ficha técnica",
      privacy: "Proteção de dados",
    },
    shareProfile: "Partilhar perfil",
    currentEmployer: "Empregador atual",
    linkCopied: "Link copiado com êxito para a área de transferência",
    evalusProfile: "Perfil Evalus",
    sharingNotSuccessful: "A partilha não foi bem-sucedida.",
    showInvalidCertificates: "Mostrar certificados expirados",
    hideInvalidCertificates: "Ocultar certificados expirados",
    invalidCertificatesHint: "Certificados ocultos que foram substituídos por outros mais recentes",
    evalId: "N.º Eval-ID",
    ogCertifications: "Certificações",
    ogDescription: "Perfil público na EvalCard",
  },
  academy: {
    academy: "Academia",
    administration: "Administração",
    "my-orders": "As minhas encomendas",
    "manage-courses": "Gerir cursos",
    data: "Dados mestre",
    price: "Preço",
    "book-for-me": "Reservar para mim",
    "book-for-employee": "Reservar para funcionários",
    passing_score: "Pontuação necessária em %",
    max_exam_attempts: "Número máximo de tentativas de exame",
    max_exam_attempts_hint: "0 = ilimitado",
    exam_attempts_remaining: "Tentativas restantes: {remaining} de {max}",
    exam_attempts_used: "Tentativas: {used}",
    exam_attempts_limit_reached: "Foi atingido o número máximo de tentativas de exame",
    "edit-course": "@:edit-course",
    "all-languages-have-content": "Já existem conteúdos do curso para todos os idiomas.",
    "must-be-company-member-to-book": "Tem de ser membro de uma empresa para poder reservar cursos.",
  },
  course: {
    course: "Curso",
    courses: "Cursos",
    "my-courses": "Os meus cursos",
    "my-courses-view": "Visão geral do curso",
    content: "Conteúdo do curso",
    "edit-content": "Editar conteúdo do curso",
    learn: "Aprendizagem",
    "learn-trail": "Percurso de aprendizagem",
    exam: "Exame",
    "exam-trail": "Percurso de exame",
    section: "Área",
    addLearnSection: "Adicionar área de aprendizagem",
    addLearnTask: "Adicionar tarefa de aprendizagem",
    addExamSection: "Adicionar área de exame",
    addExamTask: "Adicionar pergunta de exame",
    sectionTitle: "Título da área",
    taskTitle: "Título da tarefa",
    questionTitle: "Título da pergunta",
    enterSectionTitle: "Introduzir título da área...",
    enterTaskTitle: "Introduzir título da tarefa...",
    enterQuestionTitle: "Introduzir título da pergunta...",
    titleRequired: "O título é obrigatório",
    titleTooShort: "O título tem de ter pelo menos 2 caracteres",
    itemAddedSuccessfully: "Elemento adicionado com êxito",
    errorAddingItem: "Erro ao adicionar o elemento",
    selectItemFromSidebar: "Selecione um elemento na barra lateral",
    task: "Tarefa",
    question: "Pergunta",
    enterTitle: "Introduzir título...",
    addItem: "Adicionar elemento",
    "purchase-course": "Comprar curso",
    "purchase-initiated": "Compra iniciada com êxito",
    "learning-objectives": "Objetivos de aprendizagem",
    prerequisites: "Requisitos",
    syllabus: "Plano curricular do curso",
    "learn-section": "Secção de aprendizagem",
    "exam-section": "Secção de exame",
    free: "Gratuito",
    booking: "Reserva",
    "purchase-date": "Reservado em",
    question_type: {
      question_type: "Tipo de pergunta",
      multiple_choice: "Escolha múltipla",
      number: "Número",
      yes_no: "Sim / Não",
    },
    operator: {
      operator: "Operador",
      equals: "Igual",
      notEquals: "Diferente",
      greaterThan: "Maior que",
      lessThan: "Menor que",
      greaterThanOrEqual: "Maior ou igual",
      lessThanOrEqual: "Menor ou igual",
    },
    correct_answer: "Resposta correta",
    yes: "Sim",
    no: "Não",
    answer: "Resposta",
    unit: "Unidade",
    select_course: "Selecionar curso",
    select_language: "Selecionar o idioma do curso",
    select_users: "Selecionar utilizador",
    error: {
      publish: "Erro ao publicar o curso",
      course_content_required: "É necessário pelo menos um conteúdo do curso",
      certification_authority_required: "É necessário pelo menos um organismo de certificação",
      certificate_template_missing: "Para cada conteúdo do curso tem de ser selecionado um modelo de certificado para todos os organismos de certificação",
      learn_section_task_required: "Cada área de aprendizagem tem de conter pelo menos uma tarefa de aprendizagem",
      exam_section_task_required: "Cada área de exame tem de conter pelo menos uma pergunta de exame",
      monetization_required: "O curso tem de estar marcado como gratuito ou ter um produto Paddle atribuído",
    },
    finish_course: "Concluir o curso",
    completed_message: "Concluiu este curso com êxito.",
    linked_exam_section: "Secção de exame associada",
    linked_exam_section_hint: "Após a conclusão desta secção de aprendizagem, esta secção de exame será apresentada",
    inline_exam_section: "Perguntas de exame",
    inline_exam_section_info: "Responda a todas as perguntas para continuar. As suas respostas são definitivas.",
    question_progress: "Pergunta {current} de {total}",
    complete_exam_section: "Concluir a secção",
    answered_during_learning: "Respondido durante a aprendizagem",
    section_already_answered: "Esta secção já foi respondida",
    answers_are_final: "As respostas já não podem ser alteradas",
  },
  enrollment: {
    status: {
      in_progress: "Iniciado",
      not_started: "Não iniciado",
      completed: "Concluído",
    },
    enrolled_courses: "Cursos inscritos",
    enroll_course: "Inscrever no curso",
    enrolled_on: "Inscrito em",
  },
  order: {
    order: "Encomenda | Encomendas",
    my_orders: "As minhas encomendas",
    view_order: "Ver",
    ordered_at: "Encomendado em",
    status: {
      paid: "Pago",
      pending: "Pendente",
      failed: "Falhou",
      refunded: "Reembolsado",
      cancelled: "Cancelado",
    },
    payment: {
      paddle: "Paddle",
      request: "Solicitação",
      none: "Nenhuma",
    },
    payment_method: "Método de pagamento",
    purchased_by: "Comprado por",
    purchased_for: "Comprado para",
    product: "Produto",
    "page-title": "Encomenda",
    thank_you: "Obrigado pela sua compra!",
    no_transaction_headline: "Encomenda não encontrada",
    no_transaction_text: "Esta encomenda não existe ou ocorreu um erro.",
    back_to_courses: "Voltar aos cursos",
    go_to_my_courses: "Para os meus cursos",
    purchase_now: "Comprar agora",
    payment_pending: "Pagamento pendente",
    payment_pending_text: "A sua encomenda foi recebida, mas o pagamento ainda não foi concluído. Conclua o pagamento para acessar o seu curso.",
    cancel_success: "Encomenda cancelada com êxito",
    cancel_error: "Erro ao cancelar a encomenda",
  },
  language: "Idioma",
  short_description: "Descrição breve",
  progress: "Progresso",
  total: "Total",
  complete_section: "Concluir a secção",
  mark_task_complete: "Marcar a tarefa como concluída",
  video_not_supported: "O seu navegador não suporta o elemento de vídeo.",
  overall_progress: "Progresso total",
  section_progress: "Progresso da secção",
  task_completed: "Tarefa concluída com êxito",
  section_completed: "Secção concluída com êxito",
  error_completing_task: "Erro ao concluir a tarefa",
  error_completing_section: "Erro ao concluir a secção",
  next: "Continuar",
  finish_learning: "Terminar a aprendizagem",
  start_learning: "Iniciar a aprendizagem",
  continue_learning: "Continuar a aprendizagem",
  take_exam_attempt: "Iniciar o exame",
  copy_course: "Copiar curso",
  select: "Selecionar",
  exam_results: {
    congratulations: "Parabéns!",
    not_passed: "Não aprovado",
    score: "Pontuação",
    you_passed: "Passou no exame com êxito!",
    need_score_to_pass: "Precisa de {score} para passar. Tente novamente.",
    score_details: "Detalhes da pontuação",
    question: "Pergunta",
    back_to_course: "Voltar ao curso",
    retake_exam: "Repetir o exame",
    view_certificate: "Mostrar certificado",
    download_certificate: "Descarregar certificado",
  },
  exam_export: {
    export_pdf: "Exportar como PDF",
    title: "Resultado do exame",
    participant: "Participante",
    birthday: "Data de nascimento",
    course: "Curso",
    attempt_number: "Tentativa",
    started_at: "Iniciado em",
    finished_at: "Concluído em",
    overall_score: "Resultado total",
    passed: "Aprovado",
    failed: "Não aprovado",
    given_answer: "Resposta dada",
    correct_answer: "Resposta correta",
    no_answer: "Sem resposta",
    yes: "Sim",
    no: "Não",
    select_attempt: "Selecionar tentativa",
    no_attempts: "Não existem tentativas concluídas",
    no_exam: "Este curso não tem exame",
    generating: "O PDF está a ser criado …",
    export_failed: "Exportação falhou",
  },
  "academy-assignment": {
    title: "Cursos da academia atribuídos",
    "academy-course": "Curso da academia",
    "available-for-regular-courses": "Selecionável para cursos regulares",
    "for-regular-courses-badge": "Para cursos regulares",
    "cannot-publish-regular-course": "Este curso não pode ser publicado porque é destinado a cursos regulares",
    language: "Idioma",
    "select-course-first": "Selecione primeiro um curso da academia",
    "no-matching-courses": "Não há cursos da academia adequados disponíveis (não publicados, aprovados, nível adequado)",
    type: "Tipo",
    "type-entry": "Teste de entrada",
    "type-intermediate": "Teste intermédio",
    "type-final": "Exame final",
    assign: "Atribuir curso da academia",
    remove: "Remover atribuição",
    "remove-warning": "Se a atribuição for removida, serão eliminadas as inscrições e os resultados de exame dos participantes para este curso da academia. Continuar?",
    "assigned-successfully": "Curso da academia atribuído com êxito",
    "removed-successfully": "Atribuição removida com êxito",
    results: "Resultados dos participantes",
    participant: "Participante",
    score: "Resultado",
    status: "Estado",
    attempts: "Tentativa",
    passed: "Aprovado",
    failed: "Não aprovado",
    "in-progress": "Em processamento",
    "not-started": "Não iniciado",
  },
  exam_interface: {
    sections: "Secções",
    overall_progress: "Progresso total",
    questions: "Perguntas",
    progress: "Progresso",
    section: "Secção",
    question_of: "Pergunta {current} de {total}",
    answered: "Respondido",
    not_answered: "Não respondido",
    previous: "Voltar",
    next: "Continuar",
    submit_exam: "Concluir o exame",
    quick_navigation: "Navegação rápida",
    submit_exam_confirm: "Entregar o exame?",
    submit_exam_message: "Tem a certeza de que quer entregar o seu exame?",
    answered_count: "Respondeu a <strong>{answered}</strong> de <strong>{total}</strong> perguntas.",
    cannot_change_warning: "Após a entrega já não pode alterar as suas respostas.",
    loading: "A carregar",
    error: "Erro",
    back: "Voltar",
    select_certificate_authority: "Selecionar organismo de certificação",
    select_authority_message: "Selecione um organismo de certificação para emitir o seu certificado.",
    no_authorities_available: "Não estão disponíveis organismos de certificação para este curso.",
    certificate_issued: "Certificado emitido com êxito!",
    error_issuing_certificate: "Erro ao emitir o certificado",
    exam_submitted_successfully: "Exame entregue com êxito!",
    exam_submit_error: "Erro ao entregar o exame",
  },
  could_not_add_section: "Não foi possível adicionar a secção",
  successfully_added_section: "Secção adicionada com êxito",
  could_not_add_task: "Não foi possível adicionar a tarefa",
  successfully_added_task: "Tarefa adicionada com êxito",
  could_not_remove_attachment: "Não foi possível remover o anexo",
  successfully_removed_attachment: "Anexo removido com êxito",
  could_not_remove_task: "Não foi possível remover a tarefa",
  successfully_removed_task: "Tarefa removida com êxito",
  could_not_remove_section: "Não foi possível remover a secção",
  successfully_removed_section: "Secção removida com êxito",
  "default-academy-issuer": "Emissor predefinido de certificados da academia",
  "default-academy-issuer-hint": "Emite automaticamente os certificados dos cursos da academia concluídos, exceto se o participante já tiver um certificado de outro organismo atribuído ao curso. Só pode existir um organismo predefinido.",
  "academy-documents": "Documentos da academia",
  "back-to-documents": "Voltar aos meus documentos",
  "completed-on": "Concluído em",
  "my-documents-academy": "Os meus documentos da academia",
  "from-task": "Da tarefa",
  "from-section": "Da secção",
  "no-documents-in-course": "Não há documentos disponíveis neste curso",
  "unknown-course": "Curso desconhecido",
  "error-loading-documents": "Erro ao carregar os documentos",
}
